import { useMutation } from "@apollo/client/react";
import { CREATE_SKYNET_USER } from "../../mutations/rolesAndPermissions/createSkynetUser";
import GET_USERS from "../../queries/rolesAndPermissions/getUsers";

export const useCreateSkynetUser = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [createSkynetUser, { data, loading, error }] = useMutation(
    CREATE_SKYNET_USER,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_USERS],
      awaitRefetchQueries: true,
    },
  );

  return { createSkynetUser, data, loading, error };
};
